import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

interface SubscriptionPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubscribe: () => void;
  usage: {
    current: number;
    limit: number;
    isSubscribed: boolean;
  };
}

export const SubscriptionPromptModal = ({ isOpen, onClose, onSubscribe, usage }: SubscriptionPromptModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Usage Limit Reached</DialogTitle>
          <DialogDescription>
            You've used {usage.current} out of {usage.limit} images this month.
            <br />
            <br />
            {usage.isSubscribed 
              ? "You've reached the maximum number of images for your current plan."
              : "Upgrade to LinkPilot Pro to generate up to 200 images per month and unlock premium features."}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
          {!usage.isSubscribed && (
            <Button onClick={onSubscribe}>
              Upgrade Now
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}; 